import { render, staticRenderFns } from "./MealRow.vue?vue&type=template&id=1b164813&scoped=true&"
import script from "./MealRow.vue?vue&type=script&lang=js&"
export * from "./MealRow.vue?vue&type=script&lang=js&"
import style0 from "./MealRow.vue?vue&type=style&index=0&id=1b164813&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b164813",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
